import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
/**
 * @description 创建菜单
 * @param {Function} h createElement
 * @param {Object} menu 菜单项
 */
export function elMenuItem(h, menu) {
  var icon = null;
  if (menu.hide) return '';
  if (menu.icon) icon = h("i", {
    "class": "fa fa-".concat(menu.icon)
  });else if (menu.iconSvg) icon = h("d2-icon-svg", {
    "attrs": {
      "name": menu.iconSvg
    }
  });
  // else icon = <i class="fa fa-file-o" />;

  var badge = "";
  if (menu.path === "/im/monitor" || menu.path === "/house/audit" || menu.path === "/house/auth" || menu.path === "/house/real-name" || menu.path === "/quarter/apartment/audit" || menu.path === "/brand/user" || menu.path === "/brand/apartment/audit" || menu.path === "/bnb/apartment/audit" || menu.path === "/bnb/user" || menu.path === "/user/force-real-name" || menu.path === "/user/member" || menu.path === "/consult/list") {
    badge = h("span", {
      "class": "wlc-menu-badge-number"
    }, [menu.badge > 999 ? "999+" : menu.badge]);
  } else {
    badge = h("span", {
      "class": "wlc-menu-badge"
    });
  }
  return h("el-menu-item", {
    "key": menu.path,
    "attrs": {
      "index": menu.path
    }
  }, [icon, h("span", {
    "slot": "title",
    "attrs": {
      "id": menu.path.replaceAll("/", "")
    }
  }, [menu.title || "未命名菜单", " ", menu.badge && badge])]);
}

/**
 * @description 创建子菜单
 * @param {Function} h createElement
 * @param {Object} menu 菜单项
 */
export function elSubmenu(h, menu) {
  var _this = this;
  var icon = null;
  if (menu.icon) icon = h("i", {
    "slot": "title",
    "class": "fa fa-".concat(menu.icon, " ").concat(menu.badge && "wlc-menu-badge-icon")
  });else if (menu.iconSvg) icon = h("d2-icon-svg", {
    "slot": "title",
    "attrs": {
      "name": menu.iconSvg
    }
  });else icon = h("i", {
    "slot": "title",
    "class": "fa fa-folder-o"
  });
  return h("el-submenu", {
    "key": menu.path,
    "attrs": {
      "index": menu.path
    }
  }, [icon, h("span", {
    "slot": "title"
  }, [menu.title || "未命名菜单"]), menu.children.map(function (child) {
    return createMenu.call(_this, h, child);
  })]);
}

/**
 * @description 在组件中调用此方法渲染菜单项目
 * @param {Function} h createElement
 * @param {Object} menu 菜单项
 */
export function createMenu(h, menu) {
  if (menu.children === undefined) return elMenuItem.call(this, h, menu);
  return elSubmenu.call(this, h, menu);
}